import { Text } from '@dreryk/react-components';

type DocumentTemplateNameCellProps = {
   readonly name: string;
};

export const DocumentTemplateNameCell = (props: DocumentTemplateNameCellProps): JSX.Element => {
   return (
      <Text testId={'name'} maxLines={3}>
         {props.name}
      </Text>
   );
};
